import React from 'react'
import rosie from 'assets/images/rosie-chat.png'
import styles from './NotificationBox.module.scss'

const NotificationBox = ({
  renderTitle = null,
  renderMessage,
  renderInput = null,
  renderButton = null,
}) => {
  return (
    <div className={styles.container}>
      <figure className={styles.figure}>
        <div className={styles.imgContainer}>
          <img
            loading="lazy"
            className={styles.img}
            alt="Logo de nossa assistente virtual"
            src={rosie}
          />
        </div>
      </figure>
      <div className={styles.body}>
        {renderTitle && renderTitle()}
        <div className={styles.info}>
          {renderMessage && renderMessage()}
          {renderInput && renderInput(styles.emailInput)}
          {renderButton && renderButton(styles.buttonSubmit)}
        </div>
      </div>
    </div>
  )
}

export default NotificationBox
